import { mediaUrl } from "@/lib/api";

export default function Logo({ settings, size = 40, className = "" }) {
  const brand = settings?.brand || {};
  if (brand.logo_url) {
    return (
      <img
        src={mediaUrl(brand.logo_url)}
        alt={brand.name || "Logo"}
        style={{ width: size, height: size }}
        className={`rounded-full object-cover border border-white/10 ${className}`}
        data-testid="brand-logo-image"
      />
    );
  }
  return (
    <img
      src="/logo.jpg"
      alt={brand.name || "Scalovix logo"}
      style={{ width: size, height: size }}
      className={`rounded-full object-cover border border-white/10 ${className}`}
      data-testid="brand-logo-mark"
    />
  );
}
